import React, { useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Nav, Row, Col } from 'react-bootstrap';

import OrderDetailProvider from 'providers/OrderDetailProvider';

import OrderLines from 'components/add_order/order/OrderDetail/OrderLines';
import OrderShipments from 'components/add_order/order/OrderDetail/OrderShipments';
import OrderInvoices from 'components/add_order/order/OrderDetail/OrderInvoices';
import OrderReturns from 'components/add_order/order/OrderDetail/OrderReturns';
import OrderHistory from 'components/add_order/order/OrderDetail/OrderHistory';
import OrderDetailSummary from 'components/add_order/order/OrderDetail/OrderDetailSummary';

const OrderDetail = () => {
  const { orderId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'order-items';

  const handleSelect = tab => {
    setSearchParams({ tab });
  };

  const handleOrderUpdate = useCallback(() => {
    window.dispatchEvent(new CustomEvent('order-updated'));
  }, []);

  return (
    <OrderDetailProvider>
      <div>
        <Nav variant="tabs" className="mb-3">
          <Nav.Item>
            <Nav.Link
              active={activeTab === 'order-items'}
              onClick={() => handleSelect('order-items')}
            >
              Order Items
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={activeTab === 'shipments'}
              onClick={() => handleSelect('shipments')}
            >
              Shipments
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={activeTab === 'invoices'}
              onClick={() => handleSelect('invoices')}
            >
              Invoices
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={activeTab === 'returns'}
              onClick={() => handleSelect('returns')}
            >
              Returns
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={activeTab === 'activities'}
              onClick={() => handleSelect('activities')}
            >
              Activities
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Row>
          <Col md={9} className="mb-3 mb-md-0">
            {activeTab === 'order-items' && (
              <OrderLines orderId={orderId} onOrderUpdate={handleOrderUpdate} />
            )}
            {activeTab === 'shipments' && <OrderShipments orderId={orderId} />}
            {activeTab === 'invoices' && <OrderInvoices orderId={orderId} />}
            {activeTab === 'returns' && <OrderReturns orderId={orderId} />}
            {activeTab === 'activities' && <OrderHistory orderId={orderId} />}
          </Col>

          <Col md={3}>
            <OrderDetailSummary orderId={orderId} listenToUpdates={true} />
          </Col>
        </Row>
      </div>
    </OrderDetailProvider>
  );
};

export default OrderDetail;
